import { render, staticRenderFns } from "./NcrPageShow.vue?vue&type=template&id=8278e590&"
import script from "./NcrPageShow.vue?vue&type=script&lang=js&"
export * from "./NcrPageShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports